// Client helper for the manage-restaurants Edge Function.
// All restaurant table access in the frontend MUST go through these calls — never `supabase.from("restaurants")`.
import { supabase } from "@/integrations/supabase/client";
import { getAdminSessionId } from "@/lib/adminSession";
import { getRestaurantSessionId } from "@/lib/restaurantSession";

function authBody() {
  return {
    admin_session_id: getAdminSessionId() || undefined,
    restaurant_session_id: getRestaurantSessionId() || undefined,
  };
}

async function call<T = any>(action: string, extra: Record<string, unknown> = {}): Promise<T> {
  const { data, error } = await supabase.functions.invoke("manage-restaurants", {
    body: { action, ...authBody(), ...extra },
  });
  if (error) throw new Error(error.message || "Request failed");
  if (data?.error) throw new Error(data.error);
  return data;
}

export const restaurantsApi = {
  list: () => call<{ data: any[] }>("list").then((r) => r.data || []),
  get: (id: string) => call<{ data: any }>("get", { restaurant_id: id }).then((r) => r.data),
  getCurrent: () => call<{ data: any }>("get_current").then((r) => r.data),
  create: (data: Record<string, unknown>) => call<{ data: any }>("create", { data }).then((r) => r.data),
  update: (id: string, data: Record<string, unknown>) => call("update", { restaurant_id: id, data }),
  remove: (id: string) => call("delete", { restaurant_id: id }),
};
